import { createSlice } from "@reduxjs/toolkit";
import { PaymentSummaryDto } from "../../shared/dtos/payment/PaymentSummaryDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

export const paymentSlice = createSlice({
  name: "payment",
  initialState: getInitialListState<PaymentSummaryDto>(),
  reducers: {
    ...generateListReducers<PaymentSummaryDto>(),
  },
});

export const paymentActions = paymentSlice.actions;
export default paymentSlice.reducer;
